import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { Grid, MenuItem } from '@material-ui/core';
import {
  ControlledDatePicker,
  ControlledInput,
  ControlledSelect,
  GridFormElement,
} from '../form-controls';
import { DEVICE_TYPES } from '../../pages/studies/edit-study/study-devices';
import { BODY_POSITIONS, Devices } from '../../api/studykit';
import { FormFooter } from '../styled/form-footer';
import { MuiPickersUtilsProvider } from '@dls/react-core';
import {
  AsyncSubmitHandler,
  useFormWithServerErrorHandling,
} from '../../helpers/form-error-handling';

interface DeviceFormProps {
  onSubmit: AsyncSubmitHandler<Devices>;
  onCancel: () => void;
  device?: Devices;
}

export const DeviceForm: React.FC<DeviceFormProps> = ({ onSubmit, onCancel, device }) => {
  const {
    handleSubmit,
    control,
    getValues,
    formState: { isSubmitting },
  } = useFormWithServerErrorHandling<Devices>({ defaultValues: device });

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={3}>
          <GridFormElement label={'Device Type'}>
            <ControlledSelect
              control={control}
              name={'type'}
              selectProps={{ fullWidth: true }}
              rules={{ required: true }}
            >
              {DEVICE_TYPES.map((d, i) => (
                <MenuItem value={d} key={i}>
                  <span>{d}</span>
                </MenuItem>
              ))}
            </ControlledSelect>
          </GridFormElement>
          <GridFormElement label={'Device name'}>
            <ControlledInput
              name={'name'}
              control={control}
              rules={{ required: true }}
              inputProps={{ fullWidth: true }}
            />
          </GridFormElement>
          <GridFormElement label={'Body Position'}>
            <ControlledSelect
              selectProps={{ fullWidth: true }}
              rules={{ required: true }}
              control={control}
              name={'bodyPosition'}
            >
              {Object.entries(BODY_POSITIONS)
                .filter(([_, v]) => typeof v === 'number')
                .map(([e, _]) => (
                  <MenuItem value={e} key={e}>
                    <span>{e}</span>
                  </MenuItem>
                ))}
            </ControlledSelect>
          </GridFormElement>
          <GridFormElement label={'MAC Address'}>
            <ControlledInput
              control={control}
              name={'macAddress'}
              rules={{
                validate: {
                  required: (value: any) =>
                    !value && !getValues('serial')
                      ? 'Either serial number or mac address is required'
                      : true,
                },
              }}
              inputProps={{ fullWidth: true }}
            />
          </GridFormElement>
          <GridFormElement label={'Serial number'}>
            <ControlledInput
              control={control}
              name={'serial'}
              rules={{
                validate: {
                  required: (value: any) =>
                    !value && !getValues('macAddress')
                      ? 'Either serial number or mac address is required'
                      : true,
                },
              }}
              inputProps={{ fullWidth: true }}
            />
          </GridFormElement>
          <GridFormElement label={'Usage Start'}>
            <ControlledDatePicker
              name={'usageStart'}
              control={control}
              rules={{ required: true }}
              datePickerProps={{ fullWidth: true }}
            />
          </GridFormElement>
          <GridFormElement label={'Usage End'}>
            <ControlledDatePicker
              name={'usageEnd'}
              control={control}
              rules={{ required: true }}
              datePickerProps={{ fullWidth: true }}
            />
          </GridFormElement>
        </Grid>
        <FormFooter isSubmitting={isSubmitting} onCancel={onCancel} />
      </form>
    </MuiPickersUtilsProvider>
  );
};
